export default __webpack_public_path__ + "static/media/const6.f0c9ece9.jpg";